// extracted by mini-css-extract-plugin
export var active = "_q-8";
export var addWidgetButton = "_q-9";
export var backButton = "_q-1";
export var pageContainer = "_q-2";
export var settingsContent = "_q-0";
export var sideNavContainer = "_q-6";
export var sideNavLink = "_q-7";
export var widgetContainer = "_q-5";
export var widgetSubsectionItem = "_q-3";
export var widgetSubsectionItemContent = "_q-4";